"use strict";

var _possibleConstructorReturn = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./error");

var stream_1 = require("./stream");

var CollectionType;

(function (CollectionType) {
  CollectionType[CollectionType["DOCUMENT_COLLECTION"] = 2] = "DOCUMENT_COLLECTION";
  CollectionType[CollectionType["EDGE_COLLECTION"] = 3] = "EDGE_COLLECTION";
})(CollectionType = exports.CollectionType || (exports.CollectionType = {}));

function isC8Collection(collection) {
  return Boolean(collection && collection.isC8Collection);
}

exports.isC8Collection = isC8Collection;
exports.DOCUMENT_NOT_FOUND = 1202;
exports.COLLECTION_NOT_FOUND = 1203;

var BaseCollection = /*#__PURE__*/function () {
  function BaseCollection(connection, name) {
    _classCallCheck(this, BaseCollection);

    this.isC8Collection = true;
    this.name = name;
    this._idPrefix = "".concat(this.name, "/");
    this._connection = connection;
    this.stream = new stream_1.Stream(connection, name, true, true);

    if (this._connection.c8Major >= 3) {
      this.createCapConstraint = undefined;
    }
  }

  _createClass(BaseCollection, [{
    key: "_documentPath",
    value: function _documentPath(documentHandle) {
      return "/document/".concat(this._documentHandle(documentHandle));
    }
  }, {
    key: "_documentHandle",
    value: function _documentHandle(documentHandle) {
      if (typeof documentHandle !== "string") {
        if (documentHandle._id) {
          return documentHandle._id;
        }

        if (documentHandle._key) {
          return this._idPrefix + documentHandle._key;
        }

        throw new Error("Document handle must be a document or string");
      }

      if (documentHandle.indexOf("/") === -1) {
        return this._idPrefix + documentHandle;
      }

      return documentHandle;
    }
  }, {
    key: "_indexHandle",
    value: function _indexHandle(indexHandle) {
      if (typeof indexHandle !== "string") {
        if (indexHandle.id) {
          return indexHandle.id;
        }

        throw new Error("Index handle must be a index or string");
      }

      if (indexHandle.indexOf("/") === -1) {
        return this._idPrefix + indexHandle;
      }

      return indexHandle;
    }
  }, {
    key: "_get",
    value: function _get(path, qs) {
      return this._connection.request({
        path: "/collection/".concat(this.name, "/").concat(path),
        qs: qs
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "_put",
    value: function _put(path, body) {
      return this._connection.request({
        method: "PUT",
        path: "/collection/".concat(this.name, "/").concat(path),
        body: body
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/collection/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isC8Error(err) && err.errorNum === exports.COLLECTION_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "create",
    value: function create(properties) {
      return this._connection.request({
        method: "POST",
        path: "/collection",
        body: Object.assign({}, properties, {
          name: this.name,
          type: this.type
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "onChange",
    value: function onChange(dcName) {
      var subscriptionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "subs";
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var otp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.stream.getOtp();

              case 2:
                otp = _context.sent;
                return _context.abrupt("return", this.stream.consumer(subscriptionName, dcName, {
                  otp: otp
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "properties",
    value: function properties() {
      return this._get("properties");
    }
  }, {
    key: "count",
    value: function count() {
      return this._get("count");
    }
  }, {
    key: "rename",
    value: function rename(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._connection.request({
                  method: "PUT",
                  path: "/collection/".concat(this.name, "/rename"),
                  body: {
                    name: name
                  }
                }, function (res) {
                  return res.body;
                });

              case 2:
                result = _context2.sent;
                this.name = name;
                this._idPrefix = "".concat(name, "/");
                return _context2.abrupt("return", result);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "truncate",
    value: function truncate() {
      return this._put("truncate", undefined);
    }
  }, {
    key: "drop",
    value: function drop(opts) {
      return this._connection.request({
        method: "DELETE",
        path: "/collection/".concat(this.name),
        qs: opts
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "documentExists",
    value: function documentExists(documentHandle) {
      return this._connection.request({
        method: "HEAD",
        path: "/".concat(this._documentPath(documentHandle))
      }, function () {
        return true;
      }).catch(function (err) {
        if (err.statusCode === 404) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "document",
    value: function document(documentHandle) {
      var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var result = this._connection.request({
        path: "/".concat(this._documentPath(documentHandle))
      }, function (res) {
        return res.body;
      });

      if (!graceful) return result;
      return result.catch(function (err) {
        if (error_1.isC8Error(err) && err.errorNum === exports.DOCUMENT_NOT_FOUND) {
          return null;
        }

        throw err;
      });
    }
  }, {
    key: "replace",
    value: function replace(documentHandle, newValue) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev && this._connection.c8Major >= 3) {
        var _a2;

        var rev;
        _a = opts, (_a2 = _a, rev = _a2.rev, _a2), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PUT",
        path: "/".concat(this._documentPath(documentHandle)),
        body: newValue,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "replaceDocuments",
    value: function replaceDocuments(documents) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev && this._connection.c8Major >= 3) {
        var _a3;

        var rev;
        _a = opts, (_a3 = _a, rev = _a3.rev, _a3), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PUT",
        path: "/".concat(this._documentPath('')),
        body: documents,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "update",
    value: function update(documentHandle, newValue) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev && this._connection.c8Major >= 3) {
        var _a4;

        var rev;
        _a = opts, (_a4 = _a, rev = _a4.rev, _a4), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PATCH",
        path: "/".concat(this._documentPath(documentHandle)),
        body: newValue,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "updateDocuments",
    value: function updateDocuments(documents) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev && this._connection.c8Major >= 3) {
        var _a5;

        var rev;
        _a = opts, (_a5 = _a, rev = _a5.rev, _a5), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "PATCH",
        path: "/".concat(this._documentPath('')),
        body: documents,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "remove",
    value: function remove(documentHandle) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev && this._connection.c8Major >= 3) {
        var _a6;

        var rev;
        _a = opts, (_a6 = _a, rev = _a6.rev, _a6), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "DELETE",
        path: "/".concat(this._documentPath(documentHandle)),
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "removeDocuments",
    value: function removeDocuments(documents) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      var headers = {};

      if (typeof opts === "string") {
        opts = {
          rev: opts
        };
      }

      if (opts.rev && this._connection.c8Major >= 3) {
        var _a7;

        var rev;
        _a = opts, (_a7 = _a, rev = _a7.rev, _a7), opts = __rest(_a, ["rev"]);
        headers["if-match"] = rev;
      }

      return this._connection.request({
        method: "DELETE",
        path: "/".concat(this._documentPath('')),
        body: documents,
        qs: opts,
        headers: headers
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "import",
    value: function _import(data) {
      var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a$type = _a.type,
          type = _a$type === void 0 ? "auto" : _a$type,
          opts = __rest(_a, ["type"]);

      if (Array.isArray(data)) {
        data = data.map(function (line) {
          return JSON.stringify(line);
        }).join("\r\n") + "\r\n";
      }

      return this._connection.request({
        method: "POST",
        path: "/import",
        body: data,
        isBinary: true,
        qs: Object.assign({
          type: type === null ? undefined : type
        }, opts, {
          collection: this.name
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "indexes",
    value: function indexes() {
      return this._connection.request({
        path: "/index",
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body.indexes;
      });
    }
  }, {
    key: "index",
    value: function index(indexName) {
      return this._connection.request({
        path: "/index/".concat(this._idPrefix).concat(indexName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createIndex",
    value: function createIndex(details) {
      return this._connection.request({
        method: "POST",
        path: "/index",
        body: details,
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "dropIndex",
    value: function dropIndex(indexName) {
      return this._connection.request({
        method: "DELETE",
        path: "/index/".concat(this._idPrefix).concat(indexName)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createCapConstraint",
    value: function createCapConstraint(opts) {
      if (typeof opts === "number") {
        opts = {
          size: opts
        };
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: Object.assign({}, opts, {
          type: "cap"
        }),
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createHashIndex",
    value: function createHashIndex(fields, opts) {
      if (typeof fields === "string") {
        fields = [fields];
      }

      if (typeof opts === "boolean") {
        opts = {
          unique: opts
        };
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: Object.assign({
          unique: false
        }, opts, {
          type: "hash",
          fields: fields
        }),
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createSkipList",
    value: function createSkipList(fields, opts) {
      if (typeof fields === "string") {
        fields = [fields];
      }

      if (typeof opts === "boolean") {
        opts = {
          unique: opts
        };
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: Object.assign({
          unique: false
        }, opts, {
          type: "skiplist",
          fields: fields
        }),
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createPersistentIndex",
    value: function createPersistentIndex(fields, opts) {
      if (typeof fields === "string") {
        fields = [fields];
      }

      if (typeof opts === "boolean") {
        opts = {
          unique: opts
        };
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: Object.assign({
          unique: false
        }, opts, {
          type: "persistent",
          fields: fields
        }),
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createGeoIndex",
    value: function createGeoIndex(fields, opts) {
      if (typeof fields === "string") {
        fields = [fields];
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: Object.assign({}, opts, {
          fields: fields,
          type: "geo"
        }),
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createFulltextIndex",
    value: function createFulltextIndex(fields, minLength) {
      if (typeof fields === "string") {
        fields = [fields];
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: {
          fields: fields,
          minLength: minLength,
          type: "fulltext"
        },
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "createTtlIndex",
    value: function createTtlIndex(fields, expireAfter) {
      if (typeof fields === "string") {
        fields = [fields];
      }

      return this._connection.request({
        method: "POST",
        path: "/index",
        body: {
          fields: fields,
          expireAfter: expireAfter,
          type: "ttl"
        },
        qs: {
          collection: this.name
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return BaseCollection;
}();

exports.BaseCollection = BaseCollection;

var DocumentCollection = /*#__PURE__*/function (_BaseCollection) {
  _inherits(DocumentCollection, _BaseCollection);

  function DocumentCollection(connection, name) {
    var _this;

    _classCallCheck(this, DocumentCollection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DocumentCollection).call(this, connection, name));
    _this.type = CollectionType.DOCUMENT_COLLECTION;
    return _this;
  }

  _createClass(DocumentCollection, [{
    key: "save",
    value: function save(data, opts) {
      if (typeof opts === "boolean") {
        opts = {
          returnNew: opts
        };
      }

      if (this._connection.c8Major <= 2) {
        return this._connection.request({
          method: "POST",
          path: "/document",
          body: data,
          qs: Object.assign({}, opts, {
            collection: this.name
          })
        }, function (res) {
          return res.body;
        });
      }

      return this._connection.request({
        method: "POST",
        path: "/document/".concat(this.name),
        body: data,
        qs: opts
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return DocumentCollection;
}(BaseCollection);

exports.DocumentCollection = DocumentCollection;

var EdgeCollection = /*#__PURE__*/function (_BaseCollection2) {
  _inherits(EdgeCollection, _BaseCollection2);

  function EdgeCollection(connection, name) {
    var _this2;

    _classCallCheck(this, EdgeCollection);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(EdgeCollection).call(this, connection, name));
    _this2.type = CollectionType.EDGE_COLLECTION;
    return _this2;
  }

  _createClass(EdgeCollection, [{
    key: "_documentPath",
    value: function _documentPath(documentHandle) {
      if (this._connection.c8Major < 3) {
        return "edge/".concat(this._documentHandle(documentHandle));
      }

      return "document/".concat(this._documentHandle(documentHandle));
    }
  }, {
    key: "edge",
    value: function edge(documentHandle) {
      var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.document(documentHandle, graceful);
    }
  }, {
    key: "save",
    value: function save(data, fromIdOrOpts, toId, opts) {
      if (toId !== undefined) {
        data._from = this._documentHandle(fromIdOrOpts);
        data._to = this._documentHandle(toId);
      } else if (fromIdOrOpts !== undefined) {
        opts = fromIdOrOpts;
      }

      if (typeof opts === "boolean") {
        opts = {
          returnNew: opts
        };
      }

      if (this._connection.c8Major <= 2) {
        return this._connection.request({
          method: "POST",
          path: "/edge",
          body: data,
          qs: Object.assign({}, opts, {
            collection: this.name,
            from: data._from,
            to: data._to
          })
        }, function (res) {
          return res.body;
        });
      }

      return this._connection.request({
        method: "POST",
        path: "/document",
        body: data,
        qs: Object.assign({}, opts, {
          collection: this.name
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "_edges",
    value: function _edges(documentHandle, direction) {
      return this._connection.request({
        path: "/edges/".concat(this.name),
        qs: {
          direction: direction,
          vertex: this._documentHandle(documentHandle)
        }
      }, function (res) {
        return res.body.edges;
      });
    }
  }, {
    key: "edges",
    value: function edges(vertex) {
      return this._edges(vertex, undefined);
    }
  }, {
    key: "inEdges",
    value: function inEdges(vertex) {
      return this._edges(vertex, "in");
    }
  }, {
    key: "outEdges",
    value: function outEdges(vertex) {
      return this._edges(vertex, "out");
    }
  }, {
    key: "traversal",
    value: function traversal(startVertex, opts) {
      return this._connection.request({
        method: "POST",
        path: "/traversal",
        body: Object.assign({}, opts, {
          startVertex: startVertex,
          edgeCollection: this.name
        })
      }, function (res) {
        return res.body.result;
      });
    }
  }]);

  return EdgeCollection;
}(BaseCollection);

exports.EdgeCollection = EdgeCollection;

function constructCollection(connection, data) {
  var Collection = data.type === CollectionType.EDGE_COLLECTION ? EdgeCollection : DocumentCollection;
  return new Collection(connection, data.name);
}

exports.constructCollection = constructCollection;